import env from './env';

// REACT_APP_API points at the v1 root; strip the trailing version segment to
// get the base the versioned URLs are built from.
const API_BAZ = env.API.replace(/v1\/?$/, '');

export const API_URL = API_BAZ + 'v1';

export const SSO_API = env.SSO_API_URL;

export const RESPONSE_TABLE_SIZE = env.RESPONSE_TABLE_SIZE;

export const HIGHCHARTS_EXPORT_URL = env.HIGHCHARTS_EXPORT_URL;

export const INTERCOM_APP_ID = env.INTERCOM_APP_ID;

export const METRICS_ENDPOINT = env.METRICS_ENDPOINT;

export const REACT_APP_VERSION = env.VERSION;
export const REACT_APP_COOKIES_DOMAIN = env.COOKIES_DOMAIN;
export const RELEASE_STAGE = env.RELEASE_STAGE;

// ::: sibling apps
export const INSYT_APP_URL = env.INSYT_APP_URL;
export const REACT_APP_ANALYTICS_APP_URL = env.ANALYTICS_APP_URL;
export const REACT_APP_ABIS_APP_URL = env.ABIS_APP_URL;
export const PUSH_APP_URL = env.PUSH_APP_URL;
export const PEOPLE_APP_URL = env.PEOPLE_APP_URL;
export const ACCOUNT_APP_URL = env.ACCOUNT_APP_URL;
export const SSO_WEB_URL = env.SSO_WEB_URL;

export const WEBSITE_HOME = env.WEBSITE_HOME;
export const STORAGE_PRFX = env.STORAGE_PREFIX;
export const PRICES_API_URL = env.PRICES_API_URL;
export const PRICE_FORMS = env.PRICES_FORM_UUIDS;
// ::: billing
export const BILLING_UNLIMITED_SLOTS = 10000000;
export const USD_TO_GHS = env.USD_TO_GHS;
export const GHS_TO_USD = env.GHS_TO_USD;

// ::: survey-api subscription billing
export const SURVEY_API_URL = env.SURVEY_API;
export const USE_SURVEY_BILLING = env.USE_SURVEY_BILLING;

// ::: album
export const ALBUM_EXTRA_FIELDS_COUNT = env.ALBUM_EXTRA_FIELDS_COUNT;

// ::: qa3
export const RESPONSE_FLAGS = env.RESTRICT_RESPONSE_FLAGS;
export const RESPONSE_FLAGS_ROLE = env.RESTRICT_RESPONSE_FLAGS_ROLE;
export const RESPONSE_FLAGS_UPDATE = env.RESTRICT_RESPONSE_FLAGS_UPDATE;

// ::: predefined comments
export const REJECT_COMMENTS = env.REJECT_WITH_CANNED_MESSAGES;

// ::: option tree
export const TREE_LEVELS = env.TREE_LEVELS;

export const dev = window.location.hostname === 'localhost' ? true : false;
export const PrimaryColor = '#05548d';

export const insytWebFormsUrl = env.WEB_FORMS_URL + '/form';

export const SUPPORTED_LANGS = ['en', 'fr', 'sw'];
